
    <span [ngClass]="className" *ngFor="let message of messages()">{{message}}</span>
  